import "./SignupActions.css";


// The wizard's action bar. Pinned to the bottom of the content column on every step, so the
// button that moves you forward is always in the same place however tall the step happens to be
// — a plan catalog and a two-field form otherwise put it in wildly different spots.
//
// Anything passed in sits on the left; the primary action carries ms-auto and lands on the right.
export default function SignupActions(props: { children: any }) {
    return (
        <div className="signup-actions">
            {/* Full width on purpose, whatever the step above it happens to be: the bar reads as
                the bottom of the page rather than as part of the form, and the button that moves
                you forward always sits in the same corner. */}
            <div className="signup-actions-inner">
                {props.children}
            </div>
        </div>
    );
}
